// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 354) return "354~v017cc602780ce0b924cd.js";
	if (chunkId === 838) return "838~v442d4763370345c45986.js";
	if (chunkId === 661) return "661~v5f6d1229bcfd31994916.js";
	// return url for filenames based on template
	return undefined;
};